const styles = {
  editor: {
    width: 250,
    mt: 3,
    backgroundColor: "primary.main",
    pl: 3,
    pt: 3,
    borderRadius: 4,
    overflow: "hidden",
  },
  whiteBg: {
    fontSize: 12,
    p: 2,
    backgroundColor: "white",
    borderTopLeftRadius: "16px",
  },
  mergeTag: {
    backgroundColor: "purple.light",
    px: 0.5,
    py: 0.3,
    borderRadius: 3,
    fontWeight: 600,
  },
  claimFree: {
    width: "max-content",
    mt: 3,
    backgroundColor: "yellow.main",
    px: 3,
    borderRadius: 6,
    fontSize: 18,
    textTransform: "none",
    color: "black",
  },
};

export default styles;
